import { DateFields, getServiceNameViaPoint, isEmpty } from '@sigma-frontend-libs/commons'

import { getLocaleDateString, getLocaleTimeString } from '@/utils'

import render from './render'

export default {
  name: 'Entity',

  props: {
    value: {
      type: Object,
      default: undefined
    },

    service: {
      type: String,
      required: true
    },

    fields: {
      type: Array,
      default: () => {
        return []
      }
    },

    pathToLabels: {
      type: String,
      default: undefined
    },

    pinTimestamps: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    prefix() {
      return this.pathToLabels || `${getServiceNameViaPoint(this.service)}.labels`
    },

    timestamps() {
      const result = []
      for (const key of Object.values(DateFields)) {
        if (this.fields.includes(key) && !isEmpty(this.value[key])) {
          result.push({
            title: this.getTranslate(`${this.prefix}.${key}`),
            value: [
              getLocaleDateString(this.value[key]),
              getLocaleTimeString(this.value[key])
            ].filter(Boolean).join(' '),
            rawDate: new Date(this.value[key])
          })
        }
      }

      return result.sort((a, b) => {
        return a.rawDate - b.rawDate
      }).map(({ title, value }) => {
        return {
          title,
          value
        }
      })
    },

    rows() {
      const result = []
      for (const key of Object.keys(this.value || {})) {
        if (Object.values(DateFields).includes(key)) {
          continue
        }
        if (this.fields.includes(key) && !isEmpty(this.value[key])) {
          result.push({
            title: this.getTranslate(`${this.prefix}.${key}`),
            value: this.value[key]
          })
        }
      }

      if (this.pinTimestamps) {
        return this.timestamps.concat(result)
      }

      return result.concat(this.timestamps)
    }
  },

  render
}
